module.exports = __webpack_public_path__ + "static/media/TONIC.24bf6cec.svg";